/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './SiteBanner.scss';

import * as React from 'react';
import cx from 'classnames';

import { Icon, Text, TextBlock, useFlags, ContentBlock } from 'sarsaparilla';

import { UsFlagIcon, GovIcon } from './site-banner-icons';

export function SiteBanner() {
    const [isOpen, setIsOpen] = React.useState(false);
    const { officialGovernmentWebsiteBanner } = useFlags();

    if (!officialGovernmentWebsiteBanner) return null;

    return (
        <section
            className="r1s--site-banner"
            aria-label="Official website of the United States government"
        >
            <div className="accordion">
                <header className="header">
                    <ContentBlock isFullWidth={true} className="header-inner">
                        <UsFlagIcon
                            width={16}
                            height={11}
                            aria-hidden="true"
                            className="flag"
                        />
                        <div className="text-group">
                            <div>An official website of the United States government</div>
                            <div className="faux-button">
                                <div className="faux-button-inner">
                                    <span>Here’s how you know</span>
                                    <Icon
                                        iconName={
                                            isOpen ? 'chevron-down' : 'chevron-right'
                                        }
                                        size="sm"
                                    />
                                </div>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="button"
                            aria-expanded={isOpen}
                            aria-controls="gov-banner"
                            onClick={() => {
                                setIsOpen((prev) => !prev);
                            }}
                        >
                            <span className="button-text">
                                <span>Here’s how you know</span>
                                <Icon
                                    iconName={isOpen ? 'chevron-down' : 'chevron-right'}
                                    size="sm"
                                />
                            </span>
                        </button>
                    </ContentBlock>
                </header>
                <div
                    className={cx('accordion-content', { 'is-open': isOpen })}
                    id="gov-banner"
                >
                    <HowYouKnow />
                </div>
            </div>
        </section>
    );
}

function HowYouKnow() {
    return (
        <div className="how-you-know">
            <ContentBlock isFullWidth={true}>
                <div className="inner">
                    <div className="item">
                        <div className="icon-wrap gov">
                            <GovIcon aria-hidden="true" />
                        </div>

                        <TextBlock>
                            <Text tag="div" fontWeight="semibold" size="lg">
                                Official websites use .gov
                            </Text>
                            <p className="explainer mb-0">
                                A <strong>.gov</strong> website belongs to an official
                                government organization in the United States.
                            </p>
                        </TextBlock>
                    </div>
                    <div className="item">
                        <div className="icon-wrap lock">
                            <Icon iconName="lock" size="lg" aria-hidden="true" />
                        </div>

                        <TextBlock>
                            <Text tag="div" fontWeight="semibold" size="lg">
                                Secure .gov websites use HTTPS
                            </Text>
                            <p className="explainer mb-0">
                                A <strong>lock icon</strong> or <strong>https://</strong>{' '}
                                means you’ve safely connected to the .gov website. Share
                                sensitive information only on official, secure websites.
                            </p>
                        </TextBlock>
                    </div>
                </div>
            </ContentBlock>
        </div>
    );
}
